export default __webpack_public_path__ + "static/media/0xf868939ee81f04f463010bc52eab91c0839ef08c.7f3ebfac.webp";